export const sessionResultsFilter = {
    namespaced: true,

    state: {
        selectedAthletes: [],
        selectedCrews: []
    },

    getters: {
        selectedAthletes(state) {
            return state.selectedAthletes;
        },

        selectedCrews(state) {
            return state.selectedCrews;
        }
    },

    mutations: {
        clearFilter(state) {
            state.selectedAthletes = [];
            state.selectedCrews = [];
        },

        selectAthlete(state, athleteId) {
            const index = state.selectedAthletes.indexOf(athleteId);
            if (index === -1) {
                state.selectedAthletes.push(athleteId);
            }
        },

        deselectAllAthlete(state) {
            state.selectedAthletes = [];
        },

        deselectAthlete(state, athleteId) {
            const athletesFromSelectedCrews = [];
            _.each(state.selectedCrews, crew => athletesFromSelectedCrews.push(...crew.crew_users));
            const isSelectedInCrew = _.uniq(athletesFromSelectedCrews).includes(athleteId);

            const index = state.selectedAthletes.indexOf(athleteId);

            if (!isSelectedInCrew && index !== -1) {
                state.selectedAthletes.splice(index, 1);
            }
        }
    },

    actions: {
        selectAthlete(context, athleteId) {
            context.commit('selectAthlete', athleteId);
        },

        deselectAllAthletes(context) {
            context.commit('deselectAllAthlete');
        },

        deselectAthlete(context, athleteId) {
            context.commit('deselectAthlete', athleteId);
        },

        selectSquad(context, squad) {
            _.each(squad.squad_users, athlete => {
                context.commit('selectAthlete', athlete);
            });
        },

        deselectSquad(context, squad) {
            _.each(squad.squad_users, athlete => {
                context.commit('deselectAthlete', athlete);
            });
        },

        selectCrew(context, crew) {
            const crewInFilter = _.find(context.state.selectedCrews, crew);
            if (!crewInFilter) {
                context.state.selectedCrews.push(crew);

                _.each(crew.crew_users, athlete => {
                    context.commit('selectAthlete', athlete);
                });
            }
        },

        deselectCrew(context, crew) {
            const index = _.findIndex(context.state.selectedCrews, crew);
            if (index !== -1) {
                context.state.selectedCrews.splice(index, 1);

                _.each(crew.crew_users, athlete => {
                    context.commit('deselectAthlete', athlete);
                });
            }
        }
    }
};
